import React from 'react';

const PracticeTab = ({
  practiceForm,
  setPracticeForm,
  practiceError,
  practiceSuccess,
  isLoggingPractice,
  onSubmit
}) => {
  return (
    <div className="emit-chat-container">
      <div className="emit-card">
        <h2 style={{ marginBottom: '24px', color: 'var(--deep-blue)' }}>
          📝 Log Your Practice
        </h2>

        {practiceSuccess && (
          <div style={{ 
            padding: '12px', 
            background: 'rgba(72, 201, 176, 0.1)', 
            borderRadius: '8px',
            color: 'var(--accent-teal)',
            marginBottom: '16px'
          }}>
            {practiceSuccess}
          </div>
        )}

        {practiceError && (
          <div style={{ 
            padding: '12px', 
            background: 'rgba(231, 76, 60, 0.1)', 
            borderRadius: '8px',
            color: '#e74c3c',
            marginBottom: '16px'
          }}>
            {practiceError}
          </div>
        )}

        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              MindStream
            </label>
            <select
              className="form-control"
              value={practiceForm.mindstream_type}
              onChange={(e) => setPracticeForm({...practiceForm, mindstream_type: e.target.value})}
              style={{ padding: '12px', borderRadius: '12px', border: '1px solid #E2E8F0', width: '100%' }}
            >
              <option value="power">🔵 Power - Bible Study & Prayer</option>
              <option value="flow">🔴 Flow - Meditation & Worship</option>
              <option value="clarity">🟢 Clarity - Service & Reflection</option>
            </select>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              Practice Name
            </label>
            <input
              type="text"
              className="form-control"
              value={practiceForm.practice_name}
              onChange={(e) => setPracticeForm({...practiceForm, practice_name: e.target.value})}
              placeholder="e.g., Morning Prayer, Romans Study"
              style={{ padding: '12px', borderRadius: '12px', border: '1px solid #E2E8F0', width: '100%' }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              Duration (minutes)
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button
                type="button"
                onClick={() => {
                  const newValue = Math.max(1, parseInt(practiceForm.duration_minutes || 1) - 1);
                  setPracticeForm({...practiceForm, duration_minutes: newValue});
                }}
                style={{
                  width: '48px',
                  height: '48px',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #4A90E2, #6CB4EE)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                −
              </button>
              <input
                type="number"
                className="form-control"
                value={practiceForm.duration_minutes}
                onChange={(e) => setPracticeForm({...practiceForm, duration_minutes: e.target.value})}
                min="1"
                style={{ 
                  padding: '12px', 
                  borderRadius: '12px', 
                  border: '1px solid #E2E8F0',
                  flex: 1,
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: '600'
                }}
              />
              <button
                type="button"
                onClick={() => {
                  const newValue = parseInt(practiceForm.duration_minutes || 1) + 1;
                  setPracticeForm({...practiceForm, duration_minutes: newValue});
                }}
                style={{
                  width: '48px',
                  height: '48px',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #4A90E2, #6CB4EE)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                +
              </button>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              Quality Rating (1-10)
            </label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <button
                type="button"
                onClick={() => {
                  const newValue = Math.max(1, parseInt(practiceForm.quality_rating || 1) - 1);
                  setPracticeForm({...practiceForm, quality_rating: newValue});
                }}
                style={{
                  width: '48px',
                  height: '48px',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #4A90E2, #6CB4EE)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                −
              </button>
              <input
                type="number"
                className="form-control"
                value={practiceForm.quality_rating}
                onChange={(e) => setPracticeForm({...practiceForm, quality_rating: e.target.value})}
                min="1"
                max="10"
                style={{ 
                  padding: '12px', 
                  borderRadius: '12px', 
                  border: '1px solid #E2E8F0',
                  flex: 1,
                  textAlign: 'center',
                  fontSize: '18px',
                  fontWeight: '600'
                }}
              />
              <button
                type="button"
                onClick={() => {
                  const newValue = Math.min(10, parseInt(practiceForm.quality_rating || 1) + 1);
                  setPracticeForm({...practiceForm, quality_rating: newValue});
                }}
                style={{
                  width: '48px',
                  height: '48px',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  background: 'linear-gradient(135deg, #4A90E2, #6CB4EE)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}
              >
                +
              </button>
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
              Insights Gained
            </label>
            <textarea
              className="form-control"
              value={practiceForm.insights_gained}
              onChange={(e) => setPracticeForm({...practiceForm, insights_gained: e.target.value})}
              rows="4"
              placeholder="What did you learn or experience?"
              style={{ padding: '12px', borderRadius: '12px', border: '1px solid #E2E8F0', width: '100%' }}
            />
          </div>

          <button
            type="submit"
            disabled={isLoggingPractice}
            style={{
              width: '100%',
              padding: '16px',
              background: 'linear-gradient(135deg, var(--primary-blue), var(--light-blue))',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: isLoggingPractice ? 'not-allowed' : 'pointer',
              opacity: isLoggingPractice ? 0.6 : 1
            }}
          >
            {isLoggingPractice ? 'Logging...' : 'Log Practice'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PracticeTab;
